import {
  ChooseStationStepFormFieldsEnum,
  IPlaceInfoLandingModel,
  yupLanding,
} from "@ryde/utils-landings";

export const yupChooseStationLandingValidationSchema = {
  [ChooseStationStepFormFieldsEnum.HomeAddress]: yupLanding
    .object<IPlaceInfoLandingModel>()
    .shape({
      fullAddress: yupLanding.string().required(),
      latitude: yupLanding.number().nullable().optional(),
      longitude: yupLanding.number().nullable().optional(),
    })
    .required(),
  [ChooseStationStepFormFieldsEnum.SourceStation2Id]: yupLanding
    .number()
    .required(),
  [ChooseStationStepFormFieldsEnum.AcceptTerms]: yupLanding
    .boolean()
    .required(),
};
